import { useState } from "react";
import {
  IconButton,
  Popover,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import { Info } from "@mui/icons-material";

// These must be imported if used:
import FormulaMillerTds from "../FormulaMillerTds"; // Adjust path accordingly
import FormulaBrokerage from "../FormulaBrokerage"; // Adjust path accordingly

const AmountInfo = ({ data }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "formula-popover" : undefined;

  const weights = [
    { label: "GST Charge", value: `${Number(data.miller_gst_charge ?? 0).toFixed(2)}%` },
    { label: "Advance", value: `₹ ${Number(data.miller_advance ?? 0).toFixed(0)}/-` },
    { label: "Bill Amount", value: `₹ ${Number(data.miller_bill_amount ?? 0).toFixed(0)}/-` },
    {
      label: "TDS",
      value: (
        <Typography style={{ fontSize: "0.775rem" }}>
          <FormulaMillerTds
            tds_rate={Number(data.miller_tds).toFixed(2)}
            gst={Number(data.miller_gst_charge).toFixed(2)}
            bill_amount={Number(data.miller_bill_amount).toFixed(0)}
          />
        </Typography>
      ),
    },
    { label: "Other Deduction", value: `₹ ${Number(data.other_deduction ?? 0).toFixed(0)}/-` },
    { label: "Final Amount", value: `₹ ${Number(data.miller_final_amount ?? 0).toFixed(0)}/-` },
  ];

  return (
    <>
      <Box display="flex" alignItems="center">
        <Typography 
          onClick={handleOpen}fontSize="0.775rem" sx={{ textDecoration: "underline",
                                textUnderlineOffset: "4px",
                                cursor: "pointer",}}>
         {`₹ ${Number(data.miller_final_amount ?? 0).toFixed(0)}/-`}
        </Typography>
        {/* <IconButton
          size="small"
          sx={{ paddingLeft: "4px" }}
        >
          <Info fontSize="inherit" />
        </IconButton> */}
      </Box>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2, display: "flex", flexDirection: "column", minWidth: "240px" }}>
          <Typography fontSize="0.8rem" fontWeight="bold" mb={1}>
            Amount Details
          </Typography>
          {weights.map((item, index) => (
            <Box key={index} mb={index < weights.length - 1 ? 1 : 0}>
              <Typography
                fontSize="0.775rem"
                display="flex"
                justifyContent="space-between"
                gap={1}
              >
                <span style={{ color: "#6b7280" }}>{item.label}:</span>
                <span>{item.value}</span>
              </Typography>
              {index < weights.length - 1 && <Divider sx={{ my: 1 }} />}
            </Box>
          ))}
        </Box>
      </Popover>
    </>
  );
};

export default AmountInfo;
